@if (!showLoadResult) {
  <mat-progress-spinner mode="indeterminate" [diameter]=20></mat-progress-spinner>
}
@if (showLoadResult) {
  <div class="mat-elevation-z8">
    <mat-horizontal-stepper #loadStepper [selectedIndex]="3">
      <mat-step>
        <ng-template matStepLabel>System components</ng-template>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Data source</ng-template>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Data review</ng-template>
        @if (showLoadDataView) {
          <app-flow-rate-chart-new></app-flow-rate-chart-new>
          <div class="actions">
            <button mat-raised-button color="primary" (click)="addNewLoadItemData()">Add new item</button>
            @if ((showRevertAllDataBtn$ | async)) {
              <button mat-raised-button (click)="revertAllData()"
                color="primary">Recover original
              data</button>
            }
            @if ((showRevertDataBtn$ | async)) {
              <button mat-raised-button (click)="revertData()" color="primary">Revert
                removed
              item</button>
            }
            <button mat-raised-button (click)="loadReviewStepper()" color="primary">Next</button>
          </div>
          <app-data-table></app-data-table>
        }
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Coefficients</ng-template>
        <app-simulation-result></app-simulation-result>
      </mat-step>
    </mat-horizontal-stepper>
  </div>
}